import React from 'react';
import PropTypes from 'prop-types';
import SimpleHeader from '../../headers/simpleHeader';
import Actions from '../containers/Actions';
import ServiceDetailsForm from '../containers/ServiceDetailsForm';
import Assignments from '../containers/Assignments';
import { STEPS } from '../constants';

const STEPS_RENDERERS = {
  [STEPS.details]: {
    component: ServiceDetailsForm,
    getTitle: ({ params: { serviceId } }) => (serviceId ? 'Edit service' : 'Add service'),
  },
  [STEPS.assignments]: {
    component: Assignments,
    getTitle: () => 'Assign service',
  },
};

const ServicesWrapper = (props) => {
  const { step, redirectUrl } = props;
  const { component: StepComponent, getTitle } = STEPS_RENDERERS[step];

  return (
    <div className="c-wrapper s-v2">
      <SimpleHeader heading={getTitle(props)}>
        <Actions baseUrl={redirectUrl} {...props} />
      </SimpleHeader>
      <StepComponent {...props} />
    </div>
  );
};


ServicesWrapper.propTypes = {
  step: PropTypes.string.isRequired,
  redirectUrl: PropTypes.string,
};

ServicesWrapper.defaultProps = {
  redirectUrl: '',
  deleteService: null,
};

export default ServicesWrapper;
